/**
 * Maps deployed hostnames to Datadog `env` values.
 * Stamp patterns match .iac hostnames; vanity hosts come from ingress rules/1.
 */
const ENVIRONMENT_BY_HOST_PATTERN: Record<string, string> = {
  "go.prod": "production",
  "practice.prod": "practice",
  "next.prod": "next",
  "stage.devtest": "stage",
  "qa.devtest": "qa",
};

const ENVIRONMENT_BY_VANITY_HOST: Record<string, string> = {
  "go.servicetitan.com": "production",
  "practice.servicetitan.com": "practice",
  "next.servicetitan.com": "next",
  "stage.servicetitan.com": "stage",
};

export const getEnvironmentName = (): string => {
  const hostname = window.location.hostname || window.location.host;

  const vanity = ENVIRONMENT_BY_VANITY_HOST[hostname];
  if (vanity) {
    return vanity;
  }

  return Object.entries(ENVIRONMENT_BY_HOST_PATTERN).reduce(
    (final, [pattern, envName]) =>
      hostname.includes(pattern) ? envName : final,
    "development",
  );
};
